import { EventDetailsOutputDocument } from '@/types/graphql/types'
import { useQuery } from '@apollo/client'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { BOOKING_STATUS, EVENT_TYPE } from 'db'
import { parseInt } from 'lodash'
import { useRouter } from 'next/router'

dayjs.extend(utc)
dayjs.extend(timezone)

const bgColors = [
  'bg-cyan-100 text-cyan-800',
  'bg-yellow-100 text-yellow-800',
  'bg-red-100 text-red-800',
  'bg-green-100 text-green-800',
  'bg-blue-100 text-blue-800',
  'bg-indigo-100 text-indigo-800',
  'bg-purple-100 text-purple-800',
  'bg-pink-100 text-pink-800',
]

const useEventBodyWithTabs = () => {
  const { query } = useRouter()
  //fetch event data
  const { data } = useQuery(EventDetailsOutputDocument, {
    variables: { eventDetailsOutputId: parseInt(query.id as string) },
  })
  const course = data?.EventDetailsOutput
  const isPackage = course?.eventType?.id === EVENT_TYPE.package.id
  //get users profile images
  const images =
    course?.traineeEvents
      ?.filter(te => te?.bookingStatusId == BOOKING_STATUS.paid.id)
      ?.map(traineeEvents => traineeEvents?.trainee?.image)
      ?.filter(image => !!image && image !== '')
      ?.slice(0, 4) ?? []

  const shareLink =
    typeof window === 'undefined' ? '#' : `${window.location.href}`

  const eventDays = course?.eventDays?.filter(d => d?.deletedAt === null)
  const firstEventDay = (eventDays?.length || 0) > 0 ? eventDays![0] : undefined

  const shareMessage = `
  ${course?.titleAr}
  CME ${course?.cmeHours}
  ${course?.methodOfDelivery?.titleAr}
  ${dayjs(course?.startDate).format('DD MMM YYYY')}
  @infinity_edu_sa
  `

  return {
    data,
    course,
    isPackage,
    images,
    shareLink,
    shareMessage,
    firstEventDay,
    bgColors,
  }
}
export default useEventBodyWithTabs
